import Api from '@/services/Index';
import FinanceApi from "@/services/FinanceApi";

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return FinanceApi.get('/pos-return-days', config);
}
const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return FinanceApi.post('/pos-return-days', data);
}
const show = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return FinanceApi.get('/pos-return-days/'+id );
}
const update = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return FinanceApi.put('/pos-return-days/'+id, data );
}
const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return FinanceApi.delete('/pos-return-days/'+id );
}
export default {
    getAll,
    store,
    show,
    update,
    del
}
